'use strict';

var picturefill = require('picturefill');

// jQuery and plugins
var $ = global.jQuery;
require('owl-carousel-2/owl.carousel');

// Modules
require('./modules/masthead');
require('./modules/lightbox');
require('./modules/tabs');
require('./modules/accordion');


// Carousel
$('.carousel').owlCarousel({
	items: 1,
	mouseDrag: true,
	dots: true,
	nav: true,
	navText: '',
	loop: true
});

// Testimonials Carousel
$('.testimonial-carousel').owlCarousel({
	items: 1,
	mouseDrag: true,
	dots: true,
	nav: true,
	navText: '',
	autoplay: true,
	loop: true
});